import { ROUTES } from '@angular/router';
import { inject, LOCALE_ID, Provider } from '@angular/core';
import { LocalizedAppRoutes } from './localized-app-routes';

export function provideLocalizedRoutes(): Provider {
  return {
    provide: ROUTES,
    multi: true,
    useFactory: () => {
      const localeId = inject(LOCALE_ID);

      return LocalizedAppRoutes(localeId);
    },
  };
}
